module.exports = __webpack_public_path__ + "img/page1-bg.929e4e74.png";